export default {
  allCell: {
    width: '60px'
  },
  receivedCell: {
    textAlign: 'left',
    width: '115px'
  },
  titleCell: {
    textAlign: 'left',
    width: '20%'
  },
  fromCell: {
    textAlign: 'left',
    width: '20%'
  },
  loCell: {
    textAlign: 'left',
    width: '40%'
  }
}
